import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Dropdown, Image } from "react-bootstrap";
import toast from "react-hot-toast";
import DummyAvatar from "../../assets/images/Profile-thumbnail-small.svg";
import {
  getPendingApprovalCoursesAPI,
  approveCourseAPI,
  rejectCourseAPI,
  approveUnpublishCourseAPI,
  rejectUnpublishCourseAPI,
} from "../../redux/features/adminSlice";
import { Link } from "react-router-dom";
import { Tick } from "../svgs/Svgs";
import { format } from "date-fns";
import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";

function CourseDetailModal({ course, onClose }) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (course) {
      setIsVisible(true);
    }
  }, [course]);

  const handleClose = () => {
    setIsVisible(false);
    setTimeout(() => onClose(), 200); // Wait for animation to complete
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };

  if (!course) return null;

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    return new Date(dateString).toLocaleDateString("en-US", {
      month: "numeric",
      day: "numeric",
      year: "numeric",
    });
  };

  const getStatusBadge = (status) => {
    const statusConfig = {
      created_pending: { label: "Pending", class: "status-pending" },
      pending_unpublished: { label: "Pending", class: "status-pending" },
      approved: { label: "Approved", class: "status-approved" },
      rejected: { label: "Rejected", class: "status-rejected" },
      active: { label: "Active", class: "status-active" },
      published: { label: "Published", class: "status-active" },
      unpublished: { label: "Unpublished", class: "status-rejected" },
      declined: { label: "Declined", class: "status-rejected" },
    };

    const config = statusConfig[status] || {
      label: status,
      class: "status-default",
    };

    return (
      <span className={`status-badge rounded-3${config.class}`}>
        {config.label}
      </span>
    );
  };
  const isValidDate = (date) => {
    return date && !isNaN(new Date(date).getTime());
  };

  return (
    <>
      <style jsx>{`
        .detail-grid {
          display: grid;
          gap: 20px;
        }

        .detail-item {
          background: #f8fafc;
          border-radius: 12px;
          padding: 16px;
          border-left: 4px solid #f05203;
        }

        .detail-label {
          font-size: 0.875rem;
          font-weight: 500;
          color: #6b7280;
          margin-bottom: 4px;
          text-transform: uppercase;
          letter-spacing: 0.05em;
        }

        .detail-value {
          font-size: 1rem;
          font-weight: 500;
          color: #1f2937;
          line-height: 1.5;
        }

        .status-badge {
          display: inline-flex;
          align-items: center;
          padding: 4px 12px;
          border-radius: 6px;
          font-size: 0.875rem;
          font-weight: 500;
          text-transform: capitalize;
        }

        .status-pending {
          background: #82BD001F;
          color: #82BD00;
        }

        .status-approved {
          background: #d1fae5;
          color: #065f46;
        }

        .status-rejected {
          background: #fee2e2;
          color: #dc2626;
        }

        .status-active {
          background: #dbeafe;
          color: #1d4ed8;
        }

        .status-default {
          background: #f3f4f6;
          color: #6b7280;
        }
      `}</style>
      <div
        className="modal show"
        style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
        onClick={handleBackdropClick}
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title fw-bold">Course Details</h5>
              <button
                type="button"
                className="btn-close"
                onClick={handleClose}
              ></button>
            </div>
            <div className="modal-body">
              <div className="detail-grid">
                <div className="detail-item">
                  <div className="detail-label">Course Title</div>
                  <div className="detail-value">{course.title}</div>
                </div>

                <div className="detail-item">
                  <div className="detail-label">Description</div>
                  <div className="detail-value description-text">
                    {course.description || "No description available"}
                  </div>
                </div>

                <div className="detail-item">
                  <div className="detail-label">Unpublish Reason</div>
                  <div className="detail-value">
                    {course.unpublish_reason || "-"}
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-md-6 mb-12">
                    <div className="detail-item">
                      <div className="detail-label">Category</div>
                      <div className="detail-value">
                        {course.Category?.name || "Uncategorized"}
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-6 mb-12">
                    <div className="detail-item">
                      <div className="detail-label">Instructor</div>
                      <div className="detail-value">
                        {course.instructor?.full_name ||
                          course.instructor?.email ||
                          "-"}
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-6 mb-12">
                    <div className="detail-item">
                      <div className="detail-label">Status</div>
                      <div className="detail-value">
                        {getStatusBadge(course.status)}
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-6 mb-12">
                    <div className="detail-item">
                      <div className="detail-label">Created Date</div>
                      <div className="detail-value">
                        {isValidDate(course.created_at)
                          ? format(new Date(course.created_at), "MM-dd-yyyy")
                          : "-"}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={handleClose}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default function CoursesUnpublishRequestforAdmin({
  fetchApi,
  isCourseTable,
}) {
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const auth = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const [allData, setAllData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [showConfirmModal, setShowConfirmModal] = useState(false); // State for ConfirmationModal
  const [actionType, setActionType] = useState(null); // State to track approve/reject
  const [selectedCourseId, setSelectedCourseId] = useState(null); // State for course ID

  const fetchData = async () => {
    if (!auth.token) {
      setError("Please log in to view courses.");
      setIsLoading(false);
      return;
    }
    setIsLoading(true);
    setError(null);
    try {
      const response = await fetchApi(auth.token);
      if (response?.success) {
        setAllData(response.data.details || []);
      } else {
        throw new Error(response?.message || "Failed to fetch data");
      }
    } catch (error) {
      console.error("Failed to fetch data:", error);
      toast.error(error?.message || "Failed to fetch data. Please try again.", {
        position: "top-center",
      });
      setError(error?.message || "Failed to fetch data");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [auth.token, fetchApi]);

  const handleApproveUnpublish = async (courseId) => {
    try {
      const response = await dispatch(
        approveUnpublishCourseAPI({ token: auth.token, courseId })
      ).unwrap();
      if (response.success) {
        toast.success("Course unpublish request approved", {
          position: "top-center",
        });
        fetchData();
      } else {
        throw new Error(
          response.message || "Failed to approve unpublish request"
        );
      }
    } catch (error) {
      toast.error(error.message || "Failed to approve unpublish request", {
        position: "top-center",
      });
    }
  };

  const handleRejectUnpublish = async (courseId) => {
    try {
      const response = await dispatch(
        rejectUnpublishCourseAPI({ token: auth.token, courseId })
      ).unwrap();
      if (response.success) {
        toast.success("Course unpublish request rejected", {
          position: "top-center",
        });
        fetchData();
      } else {
        throw new Error(
          response.message || "Failed to reject unpublish request"
        );
      }
    } catch (error) {
      toast.error(error.message || "Failed to reject unpublish request", {
        position: "top-center",
      });
    }
  };

  const handleOpenConfirmModal = (courseId, action) => {
    setSelectedCourseId(courseId);
    setActionType(action);
    setShowConfirmModal(true);
  };

  const handleConfirmAction = async () => {
    if (actionType === "approve") {
      await handleApproveUnpublish(selectedCourseId);
    } else if (actionType === "reject") {
      await handleRejectUnpublish(selectedCourseId);
    }
  };

  const totalPages = Math.ceil((allData?.length || 0) / rowsPerPage);
  const startIndex = (currentPage - 1) * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  const currentRows = Array.isArray(allData)
    ? allData.slice(startIndex, endIndex)
    : [];

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handleRowsChange = (event) => {
    setRowsPerPage(Number(event.target.value));
    setCurrentPage(1);
  };

  const getStatusBadge = (status) => {
    const statusConfig = {
      created_pending: { label: "Pending", class: "status-pending" },
      pending_unpublished: { label: "Pending", class: "status-pending" },
      approved: { label: "Approved", class: "status-approved" },
      rejected: { label: "Rejected", class: "status-rejected" },
      active: { label: "Active", class: "status-active" },
      published: { label: "Published", class: "status-active" },
      unpublished: { label: "Unpublished", class: "status-rejected" },
      declined: { label: "Declined", class: "status-rejected" },
    };

    const config = statusConfig[status] || {
      label: status,
      class: "status-default",
    };

    return (
      <span className={`status-badge rounded-3 ${config.class}`}>
        {config.label}
      </span>
    );
  };

  const isValidDate = (date) => {
    return date && !isNaN(new Date(date).getTime());
  };

  if (isCourseTable) {
    return (
      <>
        {isLoading && (
          <div className="loader-container">
            <div className="dottedLoading theme-color"></div>
          </div>
        )}
        <style jsx>{`
          .status-badge {
            display: inline-flex;
            align-items: center;
            padding: 4px 12px;
            border-radius: 6px;
            font-size: 0.875rem;
            font-weight: 500;
            text-transform: capitalize;
          }

          .status-pending {
            background: #82BD001F;
            color: #82BD00;
          }

          .status-approved {
            background: #d1fae5;
            color: #065f46;
          }

          .status-rejected {
            background: #fee2e2;
            color: #dc2626;
          }

          .status-active {
            background: #dbeafe;
            color: #1d4ed8;
          }

          .status-default {
            background: #f3f4f6;
            color: #6b7280;
          }
        `}</style>
        <CourseDetailModal
          course={selectedCourse}
          onClose={() => setSelectedCourse(null)}
        />
        <ConfirmationModal
          show={showConfirmModal}
          onHide={() => setShowConfirmModal(false)}
          title={actionType === "approve" ? "Confirm Approve Unpublish Request" : "Confirm Reject Unpublish Request"}
          message={
            actionType === "approve"
              ? "Are you sure you want to approve this unpublish request?"
              : "Are you sure you want to reject this unpublish request?"
          }
          onConfirm={handleConfirmAction}
          confirmText={actionType === "approve" ? "Approve" : "Reject"}
          cancelText="Cancel"
        />
        <div className="d-flex align-item-center justify-content-end d-sm-none">
          <label className="me-2 flex-shrink-0 align-self-center">
            No of Rows
          </label>
          <select
            className="form-control ms-16"
            value={rowsPerPage}
            onChange={handleRowsChange}
            style={{ width: "100px" }}
          >
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={30}>30</option>
            <option value={40}>40</option>
            <option value={50}>50</option>
          </select>
        </div>
        <div className="table-responsive mb-10" style={{ minHeight: "200px" }}>
          <table className="table student-table custom-table align-middle">
            <thead className="position-sticky top-0">
              <tr>
                <th className="ah-text-base" width="10%">
                  Sr No.
                </th>
                <th className="ah-text-base" width="25%">
                  Course Name
                </th>
                <th className="ah-text-base" width="20%">
                  Instructor
                </th>
                <th className="ah-text-base" width="15%">
                  Category
                </th>
                <th className="ah-text-base" width="15%">
                  Created At
                </th>
                <th className="ah-text-base" width="10%">
                  Status
                </th>
                <th className="ah-text-base" width="10%">
                  Action
                </th>
              </tr>
            </thead>
            <tbody className="ah-text-sm fw-medium text-black">
              {isLoading ? (
                <tr>
                  <td colSpan="7" className="fw-normal">
                    Loading...
                  </td>
                </tr>
              ) : error ? (
                <tr>
                  <td colSpan="7">
                    <div className="alert alert-danger fw-normal">
                      Error: {error}
                    </div>
                  </td>
                </tr>
              ) : currentRows.length > 0 ? (
                currentRows.map((course, index) => (
                  <tr key={course.id}>
                    <td>
                      <div className="counter-block">
                        {startIndex + index + 1}
                      </div>
                    </td>
                    <td>
                      <div className="d-flex align-items-center">
                        <div className="img-holder me-15 flex-shrink-0">
                          <Image
                            src={
                              process.env.REACT_APP_GALLERY_URL +
                              JSON.parse(course?.image_urls)?.[0]
                            }
                            alt={`Thumbnail ${index + 1}`}
                            className="img-fluid w-100 h-100"
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = DummyAvatar;
                            }}
                          />
                        </div>
                        <strong className="ah-text-sm fw-semibold text-black">
                          {course.title}
                        </strong>
                      </div>
                    </td>
                    <td>
                      {course.instructor?.full_name ||
                        course.instructor?.email ||
                        "-"}
                    </td>
                    <td>{course.Category?.name || "-"}</td>
                    <td>
                      {isValidDate(course.created_at)
                        ? format(new Date(course.created_at), "MM-dd-yyyy")
                        : "-"}
                    </td>
                    <td>{getStatusBadge(course.status)}</td>
                    <td>
                      <Dropdown className="custom-dropdown">
                        <Dropdown.Toggle className="icon-btn p-5 m-0">
                          <svg
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <circle
                              cx="9"
                              cy="4.625"
                              r="1.09375"
                              fill="#F05203"
                            />
                            <circle cx="9" cy="9" r="1.09375" fill="#F05203" />
                            <circle
                              cx="9"
                              cy="13.375"
                              r="1.09375"
                              fill="#F05203"
                            />
                          </svg>
                        </Dropdown.Toggle>
                        <Dropdown.Menu align="end">
                          <Dropdown.Item
                            as={Link}
                            to={"/admin-course-detail?id=" + course?.id}
                          >
                            <svg
                              width="20"
                              height="13"
                              viewBox="0 0 20 13"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M10 0.539062C6.17879 0.539062 2.71351 2.62968 0.15649 6.02541C-0.0521632 6.30361 -0.0521632 6.69228 0.15649 6.97048C2.71351 10.3703 6.17879 12.4609 10 12.4609C13.8212 12.4609 17.2865 10.3703 19.8435 6.97457C20.0522 6.69637 20.0522 6.3077 19.8435 6.0295C17.2865 2.62968 13.8212 0.539062 10 0.539062ZM10.2741 10.6976C7.73755 10.8572 5.64284 8.76653 5.80239 6.22588C5.93331 4.13117 7.63118 2.4333 9.72589 2.30238C12.2625 2.14283 14.3572 4.23345 14.1976 6.7741C14.0626 8.86472 12.3647 10.5626 10.2741 10.6976ZM10.1473 8.75835C8.78081 8.84427 7.65163 7.71918 7.74164 6.35271C7.81119 5.22353 8.72763 4.31118 9.85681 4.23754C11.2233 4.15162 12.3525 5.27671 12.2625 6.64318C12.1888 7.77646 11.2724 8.6888 10.1473 8.75835Z"
                                fill="#F05203"
                              />
                            </svg>
                            View Details
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() => handleOpenConfirmModal(course.id, "approve")}
                          >
                            <Tick color="#F05203" />
                            Approve Request
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() => handleOpenConfirmModal(course.id, "reject")}
                          >
                            <svg
                              width="19"
                              height="19"
                              viewBox="0 0 19 19"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M9.5 17.7031C14.0305 17.7031 17.7031 14.0305 17.7031 9.5C17.7031 4.96954 14.0305 1.29688 9.5 1.29688C4.96954 1.29688 1.29688 4.96954 1.29688 9.5C1.29688 14.0305 4.96954 17.7031 9.5 17.7031Z"
                                stroke="#F05203"
                                strokeWidth="1.96875"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M4.57812 14.4219L15.0781 3.92188"
                                stroke="#F05203"
                                strokeWidth="1.96875"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                            Reject Request
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7">
                    <div className="alert alert-info fw-normal">
                      No courses found.
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <div className="d-flex justify-content-center justify-content-sm-between align-items-center custom-pagination-holder">
          <div className="mx-auto">
            <button
              className="me-2 border-0 bg-transparent p-0"
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
            >
              <svg
                style={{ transform: "rotate(-90deg)" }}
                width="12"
                height="10"
                viewBox="0 0 17 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.7646 8.65686L8.76465 1.65686L1.76465 8.65686"
                  stroke="#000"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              Prev
            </button>
            {[...Array(totalPages)].map((_, i) => (
              <button
                key={i + 1}
                className={`bg-transparent border-0 ${
                  currentPage === i + 1
                    ? "pagination-item active"
                    : "pagination-item"
                } me-2`}
                onClick={() => handlePageChange(i + 1)}
              >
                {i + 1}
              </button>
            ))}
            <button
              className="me-2 border-0 bg-transparent p-0"
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
            >
              Next
              <svg
                style={{ transform: "rotate(90deg)" }}
                width="12"
                height="10"
                viewBox="0 0 17 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.7646 8.65686L8.76465 1.65686L1.76465 8.65686"
                  stroke="#000"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          </div>
          <div className="align-item-center d-none d-sm-flex">
            <label className="me-2 flex-shrink-0 align-self-center">
              No of Rows
            </label>
            <select
              className="form-control ms-16"
              value={rowsPerPage}
              onChange={handleRowsChange}
              style={{ width: "100px" }}
            >
              <option value={10}>10</option>
              <option value={20}>20</option>
              <option value={30}>30</option>
              <option value={40}>40</option>
              <option value={50}>50</option>
            </select>
          </div>
        </div>
      </>
    );
  }

  // Default: Student Table
  return (
    <>
      <div className="d-flex align-item-center justify-content-end d-sm-none">
        <label className="me-2 flex-shrink-0 align-self-center">
          No of Rows
        </label>
        <select
          className="form-control ms-16"
          value={rowsPerPage}
          onChange={handleRowsChange}
          style={{ width: "100px" }}
        >
          <option value={10}>10</option>
          <option value={20}>20</option>
          <option value={30}>30</option>
          <option value={40}>40</option>
          <option value={50}>50</option>
        </select>
      </div>
      <div className="table-responsive mb-10">
        <table className="table student-table custom-table align-middle">
          <thead className="position-sticky top-0">
            <tr>
              <th className="ah-text-base" width="10%">
                Sr No.
              </th>
              <th className="ah-text-base" width="20%">
                Name
              </th>
              <th className="ah-text-base" width="20%">
                Email
              </th>
              <th className="ah-text-base" width="20%">
                Phone Number
              </th>
              <th className="ah-text-base" width="20%">
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              <tr>
                <td colSpan="5">Loading...</td>
              </tr>
            ) : error ? (
              <tr>
                <td colSpan="5">Error: {error}</td>
              </tr>
            ) : currentRows.length > 0 ? (
              currentRows.map((student, index) => (
                <tr key={student.id}>
                  <td>
                    <div className="counter-block">
                      {startIndex + index + 1}
                    </div>
                  </td>
                  <td>
                    <div className="d-flex align-items-center">
                      <div className="img-holder me-15">
                        <img
                          src={
                            student.profile_picture &&
                            student.profile_picture !== ""
                              ? student.profile_picture
                              : DummyAvatar
                          }
                          alt="Student"
                          className="img-fluid"
                          onError={(e) => (e.target.src = DummyAvatar)}
                        />
                      </div>
                      <strong className="ah-text-sm fw-semibold">
                        {student.full_name}
                      </strong>
                    </div>
                  </td>
                  <td className="fw-semibold">{student.email}</td>
                  <td className="fw-semibold">{student.phone_number}</td>
                  <td className="fw-semibold">
                    <button
                      className="btn btn-primary fw-semibold no-shadow py-7 ah-text-sm"
                      onClick={() => setSelectedCourse(student)}
                    >
                      View Details
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5">No students found.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <div className="d-flex justify-content-center justify-content-sm-between align-items-center custom-pagination-holder">
        <div className="mx-auto">
          <button
            className="me-2 border-0 bg-transparent p-0"
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
          >
            <svg
              style={{ transform: "rotate(-90deg)" }}
              width="12"
              height="10"
              viewBox="0 0 17 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15.7646 8.65686L8.76465 1.65686L1.76465 8.65686"
                stroke="#000"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            Prev
          </button>
          {[...Array(totalPages)].map((_, i) => (
            <button
              key={i + 1}
              className={`bg-transparent border-0 ${
                currentPage === i + 1
                  ? "pagination-item active"
                  : "pagination-item"
              } me-2`}
              onClick={() => handlePageChange(i + 1)}
            >
              {i + 1}
            </button>
          ))}
          <button
            className="me-2 border-0 bg-transparent p-0"
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            Next
            <svg
              style={{ transform: "rotate(90deg)" }}
              width="12"
              height="10"
              viewBox="0 0 17 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15.7646 8.65686L8.76465 1.65686L1.76465 8.65686"
                stroke="#000"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>
        <div className="align-item-center d-none d-sm-flex">
          <label className="me-2 flex-shrink-0 align-self-center">
            No of Rows
          </label>
          <select
            className="form-control ms-16"
            value={rowsPerPage}
            onChange={handleRowsChange}
            style={{ width: "100px" }}
          >
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={30}>30</option>
            <option value={40}>40</option>
            <option value={50}>50</option>
          </select>
        </div>
      </div>
    </>
  );
}
